import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Link } from '@abyss/web/ui/Link';
import find from 'lodash/find';
import { useShallow } from 'zustand/react/shallow';

import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { useLagoon } from '../../hooks/useLagoon';
import { useChipStore } from '../../store/useChipStore';
import { ChipState } from '../../store/useChipStore/chipStore';
import { getLob } from '../../utils/providerSearch.utils';
import {
  getCurrentMember,
  isDsnpMember,
  isIndividualMNRMember,
} from '../../utils/user.utils';
import { CareCategories, Constants, LOB } from '../Constants';
import { ConstantsLagoon } from '../ConstantsLagoon';
import {
  ProviderDirectoryText,
  ProviderDirectoryWrapper,
} from './DisclaimersContainer.styled';

export const ProviderDirectoryLink = () => {
  const lagoonData = (
    useLagoon(Constants.LAGOON_TABLE.UI_MESSAGING) as () => any[]
  )();

  const currentMember = getCurrentMember();
  const { storeLob } = useChipStore(
    useShallow((state: ChipState) => ({
      storeLob: state.lob,
    }))
  );

  const lob = getLob(currentMember?.lineOfBusiness, storeLob);
  const chipStore = useChipStore(useShallow((state: ChipState) => state));
  const { locale, chipValue: selectedChipValue } = chipStore;

  const providerDirectoryDisclaimerData = find(lagoonData, {
    key: ConstantsLagoon.DISCLAIMER.PROVIDER_DIRECTORY_PDF_LINK,
  });

  const [enableProviderDirectoryPdfLink] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PROVIDER_DIRECTORY_PDF_LINK,
  ]);

  const checkIndividualMnrMember = isIndividualMNRMember(currentMember);
  const checkDsnpMember = isDsnpMember(currentMember);
  const isMNReliglbe =
    lob === LOB.MNR && (checkIndividualMnrMember || checkDsnpMember);

  const isValidProviderDirectoryPdfmember =
    enableProviderDirectoryPdfLink &&
    providerDirectoryDisclaimerData &&
    selectedChipValue === CareCategories.ALL &&
    (isMNReliglbe || currentMember?.isCnSDsnpMember);

  return (
    <div>
      {isValidProviderDirectoryPdfmember ? (
        <ProviderDirectoryWrapper>
          <ProviderDirectoryText>
            {providerDirectoryDisclaimerData?.title}
          </ProviderDirectoryText>
          <Link
            aria-label={
              providerDirectoryDisclaimerData?.message ||
              'Open provider directory'
            }
            href={`/provider-directory?lob=${encodeURIComponent(
              lob || ''
            )}&locale=${locale}`}
            isStandardAnchor
            rel="noopener noreferrer"
            size={12}
            target="_blank"
          >
            {providerDirectoryDisclaimerData?.message}
            <IconSymbol color="$interactive" icon="chevron_right" size="18" />
          </Link>
        </ProviderDirectoryWrapper>
      ) : null}
    </div>
  );
};
